import React from 'react'
import '../Assets/Css/home.css'
import { Container, Row, Col, Button,Carousel, Card } from 'react-bootstrap';
import {FaCheckCircle  } from 'react-icons/fa';
import CountUp from 'react-countup';

import Banner1 from '../Assets/Images/hero slider img common.png';
import Banner2 from '../Assets/Images/hero slider img automation.png';
import Banner3 from '../Assets/Images/hero slider img 3 no.png';
import Banner4 from '../Assets/Images/hero slider img.png';

import aboutus from '../Assets/Images/About us image.png'
import whychooseaim from '../Assets/Images/why choose aim.png'

import { Helmet } from "react-helmet";
import {  FaCogs, FaIndustry, FaClock, FaShieldAlt, FaTools } from 'react-icons/fa';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import img1 from "../Assets/Images/Productrangeo1.png";
import img2 from "../Assets/Images/Productrangeo2.png";
import img3 from "../Assets/Images/Productrangeo3.png";
import img4 from "../Assets/Images/Productrangeo4.png";
import img5 from "../Assets/Images/Productrangeo5.png";
import img6 from "../Assets/Images/Productrangeo6.png";
import img7 from "../Assets/Images/Productrangeo7.png";
import img8 from "../Assets/Images/Productrangeo8.png";
import img9 from "../Assets/Images/Productrangeo9.png";
import img10 from "../Assets/Images/Productrangeo10.png";
import img11 from "../Assets/Images/Productrangeo11.png";
import img12 from "../Assets/Images/Productrangeo12.png";
import img13 from"../Assets/Images/Productrangeo13.png";
import img14 from "../Assets/Images/Productrangeo14.png";
import img15 from "../Assets/Images/Productrangeo15.png";



import pharmaImg from '../Assets/Images/pharma.png';
import foodImg from '../Assets/Images/food.png';
import dairyImg from '../Assets/Images/dairy.png';
import automationImg from '../Assets/Images/automation.png';

import client1 from '../Assets/Images/agio pharma logo.png'
import client2 from '../Assets/Images/ddenterprises_logo.jpg'
import client3 from '../Assets/Images/dinshaws.png'
import client4 from '../Assets/Images/emcure.png'
import client5 from '../Assets/Images/lupin logo.png'
import client6 from '../Assets/Images/mercedes logo.jpg'
import client7 from '../Assets/Images/poshs.jpg'
import client8 from '../Assets/Images/serum logo.png'

export default function HomePage() {
  const carouselData = [
    {
      image: Banner1,
      title: "Welcome to AIM Industrial Products",
      description: "Delivering precise and durable mechanical components for operational efficiency and reliability.",
    },
    {
      image: Banner2,
      title: "Precision That Powers Progress",
      description: "Offering unmatched quality in mechanical solutions that drive performance and innovation.",
    },
    {
      image: Banner3,
      title: "Built to Withstand, Engineered to Excel",
      description: "Crafting durable components to ensure strength, stability, and reliability under all conditions.",
    },
    {
      image: Banner4,
      title: "Innovation in Every Component",
      description: "Providing engineering excellence that drives the future of industry.",
    },
  ];
  
  const industries = [
    {
      title: 'Pharmaceutical Industry',
      description: 'Cleanroom-compatible, corrosion-resistant parts built to exacting hygiene and safety standards.',
      indimg:pharmaImg, 
    },
    {
      title: 'Automation Industry',
      description: 'Precision-engineered components for robotics, PLCs, SCADA, and motion control systems.',
      indimg:automationImg,
    },
    {
      title: 'Dairy Industry',
      description: 'Hygienic, durable, and easy-to-maintain parts to ensure continuous and efficient operations.',
      indimg:dairyImg,
    },
    {
      title: 'Food & Beverage',
      description: 'Food-grade components for safe, efficient production and packaging lines.',
      indimg:foodImg
    },
    
  ];
  
  const features = [
    "Industry-specific engineering solutions",
    "Superior material quality and finish",
    "Reliable delivery and responsive customer support",
    "Unwavering commitment to excellence in every project",
    "Strict adherence to quality standards at every stage of production",
    "Dedicated to delivering durable, efficient, and precision-engineered products"
  ];
  
  const images = [
    img1, img2,img12, img13, img3, img4, img5,
    img6, img7, img10,
    img11,  img14, img15, img8, img9,
    
  ];
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  };


  const clientLogos = [
    client1,client2,client3,client4,client5,client6,client7,client8
  ];
  
 return (
    <>
    <div className="mainnav min-vh-100 bg-light">

    <Helmet>
        <title>AIM Industrial Products | Precision Mechanical Solutions</title>
        <meta
          name="description"
          content="AIM Industrial Products specializes in high-quality, hygienic, and precision-engineered mechanical components for the pharmaceutical, dairy, food processing, and automation industries."
        />
        <meta name="keywords" content="Mechanical Components, Precision Engineering, Pharmaceutical Parts, Dairy Equipment, Food Processing Components, Automation Solutions, AIM Industrial Products" />
        <meta name="author" content="AIM Industrial Products" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph for social media sharing */}
        <meta property="og:title" content="AIM Industrial Products – Committed to Quality that Drives Performance" />
        <meta property="og:description" content="Precision mechanical components for high-hygiene industries like pharmaceuticals, dairy, food, and automation. Built for durability and reliability." />
        <meta property="og:image" content="https://aimindproducts.com/path-to-logo-or-banner.jpg" />
        <meta property="og:url" content="https://aimindproducts.com/" />
        <meta property="og:type" content="website" />

        {/* Favicon */}
        <link rel="icon" href="/favicon.ico" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://aimindproducts.com/" />
      </Helmet>

        {/* Carousel Section */}
  {/* <Carousel fade interval={3000} pause="hover">
        {carouselData.map((item, index) => (
     <Carousel.Item key={index}>
   <img className="d-block w-100 fixed-carousel-image" src={item.image} alt={`Slide ${index + 1}`} />
   <Carousel.Caption>
  <div className="container">
    <div className="row  m-0 justify-content-center">
      <div className="col-6 text-center maindesc">
        <h1 className='maintitle' >{item.title}</h1>
        <p className='text-white '>{item.description}</p>
      </div>
    </div>
  </div>
</Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel> */}

      <Carousel fade interval={3000} pause="hover">
  <Carousel.Item>
    <img className="d-block w-100 fixed-carousel-image" src={Banner1} alt="Slide 1" />
    <Carousel.Caption className='maindesc1'>
      <div className="container">
        <div className="row m-0">
          <div className="col-12 col-md-6 text-center ">
            <h1 className=' maintitle'>Welcome to AIM Industrial Products</h1>
            <p className='text-white'>Delivering precise and durable mechanical components for operational efficiency and reliability.</p>
          </div>
        </div>
      </div>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item>
    <img className="d-block w-100 fixed-carousel-image" src={Banner2} alt="Slide 2" />
    <Carousel.Caption>
      <div className="container">
        <div className="row m-0 ">
          <div className="col-12 col-md-6 text-center ">
            <h1 className='maintitle '>Precision That Powers Progress</h1>
            <p className='text-white'>Offering unmatched quality in mechanical solutions that drive performance and innovation.</p>
          </div>
        </div>
      </div>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item>
    <img className="d-block w-100 fixed-carousel-image" src={Banner3} alt="Slide 3" />
    <Carousel.Caption className='maindesc1'>
      <div className="container">
        <div className="row m-0 ">
          <div className="col-12 col-md-6 text-center ">
            <h1 className='maintitle '>Built to Withstand, Engineered to Excel</h1>
            <p className='text-white'>Crafting durable components to ensure strength, stability, and reliability under all conditions.</p>
          </div>
        </div>
      </div>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item>
    <img className="d-block w-100 fixed-carousel-image" src={Banner4} alt="Slide 4" />
    <Carousel.Caption>
      <div className="container">
        <div className="row m-0 j">
          <div className="col-12 col-md-6 text-center ">
            <h1 className='maintitle '>Innovation in Every Component</h1>
            <p className='text-white'>Providing engineering excellence that drives the future of industry.</p>
          </div>
        </div>
      </div>
    </Carousel.Caption>
  </Carousel.Item>
</Carousel>

      {/* Hero Section */}
      {/* <section className=" text-center py-4 ">
      <Container >
  <div className="d-flex justify-content-center align-items-center">
  <Col lg={10} className="text-center">
    <h2 className="Mainhead">Engineering Reliability with Every Part</h2>
    <p className=" fw-bold mb-3 ">
      AIM Industrial Products – Committed to Quality that Drives Performance
    </p>
    </Col>
    </div>
    <p className="  mb-4">
      Driven by a commitment to precision and durability, AIM provides mechanical components designed to optimize performance and ensure lasting reliability.
    </p>
    <Button  href="/products" className="btn-main">See Our Capabilities</Button>
  
</Container> 
</section> */}


{/* <section className="highlight-section text-center py-5">
  <Container>
    <Row className="align-items-center">
     
      <Col lg={6} className="text-lg-start text-center mb-4 mb-lg-0">
        <h2 className="highlight-title">
          Engineering Reliability with Every Part
        </h2>
        <p className="highlight-subtitle">
          AIM Industrial Products – Committed to Quality that Drives Performance
        </p>
        <p className="highlight-description">
          We deliver precision-engineered mechanical components that ensure optimized performance and unwavering reliability, built to meet the toughest demands.
        </p>
      </Col>

     
      <Col lg={6}>
        <div className="highlight-cta shadow-lg">
          <h4 className="cta-heading">Unlock Our Engineering Excellence</h4>
          <p className="cta-text">Explore our full range of capabilities and how we can power your performance.</p>
          <Button href="/products" className="highlight-btn">
            See Our Capabilities
          </Button>
        </div>
      </Col>
    </Row>
  </Container>
</section> */}

<section className="diagonal-banner mt-3">
  <div className="left-content">
    <div className="text-content">
      <h1 className="highlight-title">
          Engineering Reliability with Every Part
        </h1>
        <p className="highlight-subtitle">
         AIM Industrial Products – Committed to Quality that Drives Performance
        </p>
        <p className="highlight-description">
        Driven by a commitment to precision and durability, AIM provides mechanical components designed to optimize performance and ensure lasting reliability.
        </p>
    </div>
  </div>
  
  <div className="right-content">
  <div className="cta-inner">
    <p className="cta-text">
      Explore our full range of capabilities .
    </p>
    <Button href="/products" className="btn-main">
      See Our Capabilities
    </Button>
  </div>
</div>

</section>


<section className="aboutus-section py-4 bg-white">
  <Container>
  <h2 className="Mainhead mb-3">About Us</h2>
    <Row className="align-items-center ">
      {/* Image Content */}
      
      <Col lg={5} className="text-center mb-4">
       <div className='aboutimg'>
        <img src={aboutus} alt="About Us" 
        className="img-fluid rounded abouyimage"
        style={{height:'300px',width:'70%'}}
        />
        </div>
      </Col>
      
      {/* Text Content */}
      <Col lg={7} className="mb-4 ">
       
        <p className="text-dark" style={{textAlign:'justify'}}>
         <b> At AIM Industrial Products </b>, we specialize in the manufacturing and trading of precision mechanical components for high-hygiene industries such as pharmaceuticals, dairy, and food processing.
        </p>
        <p className="text-dark" style={{textAlign:'justify'}}>
          With decades of hands-on industry experience, we understand the unique operational, hygiene, and compliance challenges our clients face. Our commitment is to deliver robust, reliable, and regulation-compliant solutions that drive performance and productivity across your operations.
        </p>
      </Col>
    </Row>
  </Container>
</section>

      {/* Industries We Serve */}
      <section className="industries-section py-4 bg-white">
        <Container>
          <h2  className="Mainhead">Industries We Serve</h2>
          <p className="text-center  mb-5">
         <b> At AIM Industrial Products </b>, we specialize in delivering precision mechanical components and systems that meet the unique demands of critical industries. Our engineering expertise and reliable supply chain ensure consistent quality, hygiene, and performance—every time.
          </p>
   
<Row className="g-4">
  {industries.map((industry, index) => (
    <Col key={index} md={6} lg={3}>
      <Card className="industry-card h-100  border-0">
      <img src={industry.indimg } alt="" style={{width:'100%',height:'200px',objectFit:'cover'}} />
        <Card.Body>
          <h5 className="text-center  fw-bold">{industry.title}</h5>
          {/* Overlay for the description on hover */}
          <div className="overlay">
            <h5>{industry.description}</h5> {/* Show description as overlay */}
          </div>
        </Card.Body>
      </Card>
    </Col>
  ))}
</Row>
        </Container>
      </section>

      

      {/* Success Stats count */}
      {/* <section className="stats-section py-4 ">
        <h2 className="Mainhead">Successful outcomes </h2>
      <Container className='mt-4'>
        <Row className="text-center">
          <Col md={4} className="stats-col mb-2">
            <div className='countback p-3'>
            <h3 className="stats-count">
              <CountUp start={0} end={500} duration={2} />
              +
            </h3>
            <p className="stats-text">Projects Completed</p>
            </div>
          </Col>
          <Col md={4} className="stats-col mb-2">
          <div className='countback p-3'>
            <h3 className="stats-count">
              <CountUp start={0} end={150} duration={2} />
              +
            </h3>
            <p className="stats-text">Customers</p>
            </div>
          </Col>
          <Col md={4} className="stats-col mb-2">
          <div className='countback p-3'>
            <h3 className="stats-count">
              <CountUp start={0} end={14} duration={2} />
              +
            </h3>
            <p className="stats-text">Years of Experience</p>
         </div>
          </Col>
        </Row>
      </Container>
    </section> */}


    <section className="stats-section py-5" >
   <h2 className="Mainhead mb-4">Successful outcomes </h2>
   <div className='py-3' style={{ backgroundColor: '#655F2C' }}>
  <Container>
    <Row className="justify-content-center text-center">
      <Col md={4} className="mb-2">
        <div className="stats-circle mx-auto d-flex flex-column justify-content-center align-items-center">
          <h3 className="stats-count text-white">
            <CountUp start={0} end={500} duration={2} />+
          </h3>
          <p className="stats-text text-white">Projects Completed</p>
        </div>
      </Col>
      <Col md={4} className="mb-2">
        <div className="stats-circle mx-auto d-flex flex-column justify-content-center align-items-center">
          <h3 className="stats-count text-white">
            <CountUp start={0} end={150} duration={2} />+
          </h3>
          <p className="stats-text text-white">Customers</p>
        </div>
      </Col>
      <Col md={4} className="mb-2">
        <div className="stats-circle mx-auto d-flex flex-column justify-content-center align-items-center">
          <h3 className="stats-count text-white">
            <CountUp start={0} end={14} duration={2} />+
          </h3>
          <p className="stats-text text-white">Years of Experience</p>
        </div>
      </Col>
    </Row>
  </Container>
  </div>
</section>


    <section className="why-choose-aim-section py-4">
      <Container>
        <Row className="text-center mb-4">
          <Col>
            <h2 className="Mainhead">Why Choose AIM?</h2>
            <p className=" text-dark section-description ">
              Explore the key reasons why AIM stands out in the industry.
            </p>
          </Col>
        </Row>
        <Row className="g-4">
        <Col lg={6} md={6} sm={12}>
  <div className="features-list">
    {features.map((feature, index) => (
      <div className="feature-item" key={index}>
        <div className="feature-icon">
          {index === 0 && <FaIndustry size={20} color="#655F2C" />}
          {index === 1 && <FaTools size={20} color="#655F2C" />}
          {index === 2 && <FaClock size={20} color="#655F2C" />}
          {index === 3 && <FaShieldAlt size={20} color="#655F2C" />}
          {index === 4 && <FaCogs size={20} color="#655F2C" />}
          {index === 5 && <FaCheckCircle size={20} color="#655F2C" />}
        </div>
        <p className="mx-2 feature-description">{feature}</p>
      </div>
    ))}
  </div>
</Col>
  <Col lg={6} md={6} sm={12} className="text-center">
    <div className="feature-image">
      <img src={whychooseaim} alt="Feature" className="img-fluid" />
    </div>
  </Col>
</Row>
      </Container>
    </section>


    <Container>
      <Row className='m-0'>
       
        <Col>
        <h2 className="Mainhead">Our Product Range</h2>
          <Slider {...settings}>
            {images.map((img, index) => (
              <div key={index}>
                <img src={img}  alt={`product-${index}`} 
                style={{ width: "100%", height: "auto", padding: "10px",borderRadius:'20px' }} />
              </div>
            ))}
          </Slider>
        </Col>
      </Row>
    </Container>

    

      {/* Call to Action */}
      <section className="cta-section mt-4 text-center py-5">
        <Container>
          <h4 className='mb-4'>
          Looking for durable and compliant stainless steel components for your process lines or automation systems?</h4>
          <Button   href="/contact"  >Get in Touch</Button>
        </Container>
      </section>

      <Container className="text-center py-5 org-section">
      
          <h2 className="Mainhead mb-4">Organizations We Serve</h2>
          <div className=" logoclient-slider">
            <div className=" slideclient-track mt-4">
              {clientLogos.concat(clientLogos).map((logo, index) => (
                <div className="slideclient" key={index}>
                  <img src={logo} alt={`Client ${index + 1}`} className="client-logo" />
                </div>
              ))}
            </div>
          </div>
         
        </Container>
   
      
    </div>
    
    </>
  )
}
